export default "__VITE_ASSET__DsLBlPlG__"